import whenDomReady from 'when-dom-ready';
class NavDropdown {
    constructor(container) {
        this.promoActiveClass = 'active';
        /**
         * Handles hover IN on nav dropdown items
         * @param item
         */
        this.handleHoverIn = (item) => {
            this.activeId = item.dataset.id;
            this.render();
        };
        /**
         * Handles hover OUT on the nav dropdown container
         * @param item
         */
        this.handleContainerOut = () => {
            this.activeId = undefined;
            this.render();
        };
        /**
         * Handles the updating of HTML based on the local state variables
         */
        this.render = () => {
            for (const promo of this.promos) {
                if (promo.dataset.id === this.activeId && this.activeId !== undefined) {
                    promo.classList.add(this.promoActiveClass);
                }
                else {
                    promo.classList.remove(this.promoActiveClass);
                }
            }
        };
        // Assign variables
        this.container = container;
        this.items = Array.from(container.querySelectorAll('.js-nav-item'));
        this.promos = Array.from(container.querySelectorAll('.js-nav-promo'));
        // Assign events
        this.items.forEach(item => {
            item.addEventListener('mouseenter', () => this.handleHoverIn(item));
        });
        this.container.addEventListener('mouseleave', this.handleContainerOut);
    }
}
whenDomReady().then(() => {
    const containers = Array.from(document.querySelectorAll('.js-nav'));
    if (containers.length === 0) {
        return;
    }
    containers.forEach(container => new NavDropdown(container));
});
